module.exports = __webpack_public_path__ + "img/computer.5ec011da.png";